import React from 'react';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import { ShieldCheck } from '@phosphor-icons/react';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 border-2 border-foreground bg-secondary shadow-brutal mb-4 -rotate-3">
            <ShieldCheck size={32} weight="bold" />
          </div>
          <h1 className="font-display text-4xl md:text-6xl font-bold tracking-tight">KEBIJAKAN <span className="text-primary italic">PRIVASI</span></h1>
          <p className="text-foreground/60 mt-2 uppercase tracking-widest text-xs font-bold">Terakhir diperbarui: April 2026</p>
        </div>

        <div className="space-y-8 text-sm leading-relaxed text-foreground/80">
          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">1. Data yang Kami Kumpulkan</h2>
            <p className="mb-3">Kami mengumpulkan data berikut saat Anda menggunakan Traktirkan:</p>
            <ul className="list-disc ml-4 space-y-2">
              <li><strong>Data Akun:</strong> Nama, email, username, foto profil, dan informasi bank untuk penarikan.</li>
              <li><strong>Data Transaksi:</strong> Riwayat traktiran, jumlah, metode pembayaran, dan pesan pendukung.</li>
              <li><strong>Data Teknis:</strong> IP address, jenis browser, dan log akses untuk keamanan.</li>
              <li><strong>Data Donatur:</strong> Nama yang ditampilkan (supporter name) dan pesan yang dikirimkan.</li>
            </ul>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">2. Penggunaan Data</h2>
            <ul className="list-disc ml-4 space-y-2">
              <li>Memproses dan menampilkan transaksi traktiran.</li>
              <li>Mengirimkan notifikasi email kepada kreator saat ada dukungan masuk.</li>
              <li>Menampilkan informasi di halaman publik kreator (jika diizinkan).</li>
              <li>Menjalankan fitur overlay streaming (alert box, leaderboard, dll).</li>
              <li>Mencegah penipuan dan aktivitas yang melanggar ketentuan.</li>
              <li>Meningkatkan kualitas layanan Platform.</li>
            </ul>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">3. Perlindungan Data</h2>
            <ul className="list-disc ml-4 space-y-2">
              <li>Semua data disimpan dengan enkripsi standar industri.</li>
              <li>Kata sandi di-hash menggunakan algoritma bcrypt dan tidak disimpan dalam teks biasa.</li>
              <li>Akses ke database dibatasi hanya untuk tim operasional yang berwenang.</li>
              <li>Transaksi pembayaran diproses melalui payment gateway berlisensi (Pakasir).</li>
            </ul>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">4. Berbagi Data</h2>
            <p className="mb-3">Kami <strong>tidak menjual</strong> data pribadi Anda. Data hanya dibagikan kepada:</p>
            <ul className="list-disc ml-4 space-y-2">
              <li><strong>Payment Gateway:</strong> Untuk memproses pembayaran (Pakasir).</li>
              <li><strong>Pihak Berwenang:</strong> Jika diwajibkan oleh hukum Indonesia.</li>
              <li><strong>Overlay Publik:</strong> Nama supporter dan pesan ditampilkan di overlay streaming kreator (jika dipilih publik oleh donatur).</li>
            </ul>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">5. Cookie & Analytics</h2>
            <p>Kami menggunakan cookie esensial untuk autentikasi sesi. Kami juga menggunakan layanan analytics untuk memahami penggunaan Platform. Anda dapat menonaktifkan cookie melalui pengaturan browser Anda.</p>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">6. Hak Anda</h2>
            <ul className="list-disc ml-4 space-y-2">
              <li>Mengakses dan mengunduh data pribadi Anda.</li>
              <li>Memperbarui atau mengoreksi informasi akun.</li>
              <li>Meminta penghapusan akun dan data terkait.</li>
              <li>Menarik persetujuan atas penggunaan data kapan saja.</li>
            </ul>
            <p className="mt-3">Untuk melaksanakan hak-hak di atas, hubungi <strong>privacy@traktirkan.com</strong>.</p>
          </section>

          <section className="border-2 border-foreground bg-white p-6 shadow-brutal-sm">
            <h2 className="font-display text-xl font-bold text-foreground mb-3">7. Perubahan Kebijakan</h2>
            <p>Kami dapat memperbarui kebijakan privasi ini sewaktu-waktu. Perubahan signifikan akan diumumkan melalui email atau notifikasi di Platform. Penggunaan berkelanjutan setelah perubahan menunjukkan persetujuan Anda.</p>
          </section>
        </div>

        <div className="mt-12 text-center text-xs text-muted-foreground">
          <p>Lihat juga: <Link to="/terms" className="text-primary hover:underline font-bold">Syarat & Ketentuan</Link></p>
        </div>
      </main>
    </div>
  );
}
